export default __webpack_public_path__ + "static/media/craon26.70e7f710.jpg";